import React from 'react';
import type { BoatAd, SearchKey } from '../../../types';

type BoatOrganisationProps = {
    ad: BoatAd;
    className?: string;
    searchKey: SearchKey;
};

export function BoatOrganisation(props: BoatOrganisationProps) {
    const { ad, className = '', searchKey } = props;

    return searchKey === 'SEARCH_ID_BOAT_USED' && ad.organisation_name ? (
        <div className={className}>
            <span className="text-xs s-text-subtle">
                {ad.organisation_name}
            </span>
        </div>
    ) : null;
}
